import { ChangeDetectionStrategy, Component, ElementRef, OnChanges, Renderer2 } from '@angular/core';
import { DougShelfTalkerContentViewModel } from './doug-shelf-talker-content-view-model';
import { ShelfTalkerCardContentComponent } from '../../shelf-talker-card-content.component';

@Component({
  selector: 'app-doug-shelf-talker-content',
  templateUrl: './doug-shelf-talker-content.component.html',
  styleUrls: ['./doug-shelf-talker-content.component.scss'],
  providers: [DougShelfTalkerContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DougShelfTalkerContentComponent extends ShelfTalkerCardContentComponent implements OnChanges {
  constructor(
    public viewModel: DougShelfTalkerContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
